module.exports = __webpack_public_path__ + "img/globe-grey56.3dcd7768.svg";